import React, { useEffect, useState } from 'react';
import { OnboardingStageProps, SetLoading } from '../../Classes';
import { Button, Field, Header, Input, Message } from 'react-frontier';
import { bindFormChange } from '@tempu/components/Util';
import Validator from '@tempu/components/Validator';
import API from '../../API';

var OnboardingInfo = (props: OnboardingStageProps)=>{
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);
	
	var sendInfo = (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(props.user, {
			first_name: [{
				rule: 'length', params: [3, 32], label: 'Nombre'
			}],
			last_name: [{
				rule: 'length', params: [3, 64], label: 'Apellido'
			}],
			phone: [{
				rule: 'phone', label: 'Teléfono'
			}],
			curp: [{
				rule: /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/gi, label: 'CURP'
			}],
			rfc: [{
				rule: /^[A-Za-zñÑ&]{3,4}\d{6}\w{3}$/gi, label: 'RFC'
			}]
		});
		setErrorPrompts(prompts);
		if(!valid) return;

		setLoading(true);
		API.onboardingUserInfo(props.user).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			props.onFinish();
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado con la información de usuario (LCL-ONBRUSI-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	}
	
	var onUserChange = bindFormChange(props.user, props.setUser);
	return <div className="tp onboarding-info">
		<Header text={'Tu información'} subtext={'Información general'} />
		<Field amount={2}>
			<Input label='Nombre' value={props.user.first_name} onChange={onUserChange('first_name')} />
			<Input label='Apellido' value={props.user.last_name} onChange={onUserChange('last_name')} />
		</Field>
		<Input label='Correo electrónico' value={props.user.email} comment='Esta información no es editable' readonly />
		<Input label='Teléfono' value={props.user.phone} onChange={onUserChange('phone')} />
		<div className="divider"></div>
		<Input label='CURP' value={props.user.curp} onChange={onUserChange('curp')} />
		<Input label='RFC' value={props.user.rfc} onChange={onUserChange('rfc')} />

		<Message type='error' list={errorPrompts} />
		<div className="actions">
			<Button text='Continuar' color='black' onClick={sendInfo} />
		</div>
	</div>
}

export default OnboardingInfo;